module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/chat-1-a3746a0f04e5f4d4740264f658124731.svg";